import DOMPurify from "dompurify";

const PURIFY_CONFIG = {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "u", "b", "i", "span", "ul", "ol", "li", "a"],
    ALLOWED_ATTR: ["href", "title", "rel", "target", "class"],
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
    FORBID_TAGS: ["script", "iframe", "object", "embed", "style", "form", "input", "img"],
    FORBID_ATTR: [
        "onerror",
        "onload",
        "onclick",
        "onmouseover",
        "onfocus",
        "onblur",
        "onsubmit",
        "onchange",
        "srcset",
        "src",
        "formaction",
        "action",
        "background",
    ],
    KEEP_CONTENT: true,
    USE_PROFILES: { html: true },
    ALLOW_DATA_ATTR: false,
};

export const sanitizeHtml = (value) => {
    if (typeof value !== "string" || value.length === 0) {
        return value;
    }
    return DOMPurify.sanitize(value, PURIFY_CONFIG);
};

export const escapeHtml = (value) => {
    if (typeof value !== "string" || value.length === 0) {
        return value;
    }
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;")
        .replace(/\//g, "&#47;");
};

export const sanitizePlainText = (value) => {
    if (typeof value !== "string" || value.length === 0) {
        return value;
    }
    return DOMPurify.sanitize(value, { ALLOWED_TAGS: [], ALLOWED_ATTR: [], KEEP_CONTENT: true });
};

// Detecta si una entrada contiene caracteres tipicos de inyeccion HTML/JS. Se usa para
// validar formularios antes de enviarlos y mostrar feedback al usuario en lugar de
// modificar silenciosamente el texto.
const SUSPICIOUS_PATTERNS = [
    /<\s*\/?\s*[a-z!][^>]*>?/i,
    /<\s*script\b/i,
    /<\s*iframe\b/i,
    /<\s*img\b/i,
    /<\s*svg\b/i,
    /\bon[a-z]+\s*=/i,
    /javascript\s*:/i,
    /data\s*:\s*text\s*\/\s*html/i,
];

export const containsUnsafeContent = (value) => {
    if (typeof value !== "string" || value.length === 0) {
        return false;
    }
    return SUSPICIOUS_PATTERNS.some((pattern) => pattern.test(value));
};

export default sanitizeHtml;
